// Dropdown-click
$(document).ready(function() {
	$('.dropdown-click .dropdown-trigger').on('click', function(e) {
		e.preventDefault();

		if ($(this).closest('.dropdown-click').hasClass('active')) {
			$(this).closest('.dropdown-click').removeClass('active');
		} else {
			$(this).closest('.dropdown-click').addClass('active');
		}
	});
});
